"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = _interopRequireWildcard(require("react-select"));

var _ = _interopRequireDefault(require("./"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Select = function Select(_ref) {
  var isSearchable = _ref.isSearchable,
      isDisabled = _ref.isDisabled,
      defaultValue = _ref.defaultValue,
      name = _ref.name,
      placeholder = _ref.placeholder,
      isMulti = _ref.isMulti,
      id = _ref.id,
      options = _ref.options,
      _onChange = _ref.onChange,
      rest = _objectWithoutProperties(_ref, ["isSearchable", "isDisabled", "defaultValue", "name", "placeholder", "isMulti", "id", "options", "onChange"]);

  var styles = {
    control: function control(base, _ref2) {
      var _objectSpread2;

      var isFocused = _ref2.isFocused;
      return _objectSpread({}, base, (_objectSpread2 = {
        minWidth: '145px',
        width: '100%',
        borderRadius: '2px',
        border: 0,
        boxShadow: 'none'
      }, _defineProperty(_objectSpread2, "border", isFocused ? '1px solid #4c6072' : '1px solid #e2e5ec'), _defineProperty(_objectSpread2, "minHeight", '38px'), _defineProperty(_objectSpread2, '&:hover', '1px solid #4c6072'), _objectSpread2));
    },
    option: function option(styles, _ref3) {
      var isDisabled = _ref3.isDisabled,
          isFocused = _ref3.isFocused,
          isSelected = _ref3.isSelected;
      return _objectSpread({}, styles, {
        backgroundColor: isDisabled ? null : isSelected ? '#18af8b' : isFocused ? '#e3f5f1' : null,
        color: isDisabled ? '#ccc' : isSelected ? 'white' : 'black',
        cursor: isDisabled ? 'not-allowed' : 'default',
        ':active': _objectSpread({}, styles[':active'], {
          backgroundColor: !isDisabled && (isSelected ? '#18af8b' : '#18af8b'),
          color: isDisabled ? '#ccc' : isFocused ? 'white' : 'black'
        })
      });
    },
    valueContainer: function valueContainer(styles) {
      return _objectSpread({}, styles, {
        cursor: 'pointer',
        // width: showOptionAsCheckbox && '2000px',
        color: '#4c6072'
      });
    },
    multiValue: function multiValue(styles) {
      return _objectSpread({}, styles, {
        margin: '5px 10px 5px 0'
      });
    },
    clearIndicator: function clearIndicator(styles) {
      return _objectSpread({}, styles, {
        cursor: 'pointer'
      });
    },
    multiValueLabel: function multiValueLabel(styles) {
      return _objectSpread({}, styles, {
        cursor: 'pointer'
      });
    },
    dropdownIndicator: function dropdownIndicator(styles) {
      return _objectSpread({}, styles, {
        cursor: 'pointer'
      });
    }
  };

  var CustomClearText = function CustomClearText() {
    return 'Clear all';
  };

  var ClearIndicator = function ClearIndicator(props) {
    var _props$children = props.children,
        children = _props$children === void 0 ? _react["default"].createElement(CustomClearText, null) : _props$children,
        getStyles = props.getStyles,
        _props$innerProps = props.innerProps,
        ref = _props$innerProps.ref,
        restInnerProps = _objectWithoutProperties(_props$innerProps, ["ref"]);

    return _react["default"].createElement("div", _extends({}, restInnerProps, {
      ref: ref,
      style: getStyles('clearIndicator', props)
    }), _react["default"].createElement("div", {
      style: {
        padding: '0px 5px'
      }
    }, children));
  };

  var Option = function Option(props) {
    return _react["default"].createElement("div", null, _react["default"].createElement(_reactSelect.components.Option, props, _react["default"].createElement(_["default"].Group, null, _react["default"].createElement(_["default"].Checkbox, {
      defaultValue: props.isSelected
    }), _react["default"].createElement(_["default"].Label, null, props.label))));
  };

  return _react["default"].createElement(_reactSelect["default"], _extends({
    onChange: function onChange(v) {
      _onChange(v);
    },
    styles: styles,
    options: options,
    isSearchable: isSearchable,
    isDisabled: isDisabled,
    defaultValue: defaultValue,
    isMulti: isMulti,
    id: id,
    name: name,
    placeholder: placeholder
  }, rest));
};

Select.propTypes = {
  isSearchable: _propTypes["default"].bool,
  isDisabled: _propTypes["default"].bool,
  defaultValue: _propTypes["default"].shape({
    label: _propTypes["default"].string,
    value: _propTypes["default"].object
  }),
  name: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  isMulti: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    value: _propTypes["default"].string
  }).isRequired),
  onChange: _propTypes["default"].func
};
Select.defaultProps = {
  isSearchable: false,
  isDisabled: false,
  defaultValue: undefined,
  name: '',
  placeholder: '',
  isMulti: false,
  id: '',
  onChange: function onChange() {}
};
var _default = Select;
exports["default"] = _default;